import type { ReactNode } from "react";
import { cn } from "ui";

export interface ITableCardProps {
  children: ReactNode;
  className?: string;
}

/**
 * Wraps a `CommonTable` in a contained white surface so tables read as a single
 * card with rounded corners and a soft border / shadow.
 */
export function TableCard({ children, className }: ITableCardProps) {
  return (
    <div
      className={cn(
        "overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm",
        className,
      )}
    >
      {children}
    </div>
  );
}
